// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader-index__loaderWrapper--bu7b8B"};